import { LoginInfo, RefreshTokenRequest } from "@/services/login-service/entities/LoginEntity.ts";
//import { onHandleGetEnvironmentLocalStorage } from "@/commons/RCAttribute.ts";
import { baseUrlApi, baseUrlApiToken, BuildURLWithTenantId } from "@/commons/RootURL.ts";
import { axiosMethod } from "@/services/enums/AxiosEnum.ts";
import axios, { AxiosResponse } from "axios";
import Cookies from "universal-cookie";
import { HttpResponse } from "@/services/entities/AxiosMethod.ts";
import { UserLoginInfo } from "@/services/login-service/entities/UserLoginEntity.ts";
import { AuthenticationFunctions } from "@/commons/AuthenticationFunctions.ts";
import { HttpClientNormal } from "@/services/entities/HttpClient.ts";

export abstract class LoginManager {
  abstract refreshToken: (
    req: RefreshTokenRequest,
    loginInfoOld: LoginInfo
  ) => Promise<LoginInfo>;
  abstract logout: () => void;
  abstract getUserInformation: () => Promise<HttpResponse<UserLoginInfo>>;
}

export class LoginManagerImpl implements LoginManager {
  protected _cookies = new Cookies();
  private _timeRefresh: Date | null = null;
  private _loginInfo: LoginInfo = new LoginInfo();

  refreshToken = (
    req: RefreshTokenRequest,
    loginInfoOld: LoginInfo
  ): Promise<LoginInfo> => {
    let currentDate: Date | null = this._timeRefresh;
    if (currentDate) {
      currentDate = new Date(currentDate.getTime() + 5 * 1000);
    }
    if (!currentDate || (currentDate && new Date() > currentDate)) {
      return axios({
        method: axiosMethod.POST,
        url: `${BuildURLWithTenantId(
          baseUrlApiToken,
        )}refresh_token`,
        //url: `https://192.168.1.138:8939/root/refresh_token`,
        data: req,
      })
        .then((response) => {
          const reqTemp = new LoginInfo(response.data);
          const time =
            new Date(loginInfoOld.expiresAt).getTime() +
            reqTemp.expiresIn * 1000;
          reqTemp.expiresAt = new Date(time).toISOString();
          this._timeRefresh = new Date();
          this._loginInfo = reqTemp;
          if (reqTemp.expiresAt) {
            localStorage.setItem("LOGIN_INFO", JSON.stringify(reqTemp));
          }
          return reqTemp;
        })
        .catch((error) => {
          return error;
        });
    }
    return new Promise((resolve) => {
      resolve(this._loginInfo);
    });
  };

  logout = (_tenantId?: string, _isSwitchTenant?: boolean) => {
    // const envi = onHandleGetEnvironmentLocalStorage();
    // const host = window.location.host;
    // if (!envi && host !== "localhost:5001") {
    //   if (onHandleGetEnvironmentLocalStorage()) return;
    //   localStorage.removeItem("LOGIN_INFO");
    //   localStorage.removeItem("notificationContents");
    //   this._cookies.remove("RBAC");
    //   const urlLogout = `${BuildURLWithTenantId(
    //     baseUrlApi
    //   )}signout`;
    //   const url = new URL(urlLogout);
    //   if (tenantId) {
    //     url.searchParams.append("tenantId", tenantId);
    //   }
    //   if (isSwitchTenant) {
    //     url.searchParams.append("ist", String(isSwitchTenant));
    //   }
    //   window.location.href = url.toString();
    // }
  };

  getUserInformation = async (): Promise<HttpResponse<UserLoginInfo>> => {
    const _httpClient: HttpClientNormal = new HttpClientNormal()
    const usId = AuthenticationFunctions.getTokenDataByKey("sub");
    const url = `${BuildURLWithTenantId(
      baseUrlApi
    )}UserLogin('${usId}')`;
    return _httpClient.get(url)
      .then((response: AxiosResponse) => new HttpResponse<UserLoginInfo>(response, UserLoginInfo))
      .catch((err) => new HttpResponse<UserLoginInfo>(err?.response))
  };
}